import React from 'react';

import { ProductSkeleton } from '@sharedComponents/Skeletons';
import { ReactFCV } from '@types';

import { StyledReservationProductWrapper } from './styled';

export const ReservationProductSkeleton: ReactFCV = () => {
  return (
    <StyledReservationProductWrapper fluid={true} data-testid="reservation-product-skeleton">
      <ProductSkeleton />
    </StyledReservationProductWrapper>
  );
};
